// extracted by mini-css-extract-plugin
module.exports = {"spinnerAnimation":"customStyle_spinnerAnimation__3rEUn","spin":"customStyle_spin__5MD2s"};